// extracted by mini-css-extract-plugin
export default {"emailSentSubHeading":"emailSent_emailSentSubHeading__h9r90","emailSentFooterClass":"emailSent_emailSentFooterClass__Y225i"};